import React from "react";
import styles from "./UploadButton.module.css";
import { useSelector } from "react-redux";

import { toast } from "react-toastify";
import { store } from "../../Store/store";
import { initialState } from "../../Reducer/atomizerPageReducer";
import {
  fileUploadError,
  handleExpertInput,
  handlePageRefresh,
  handleResetCategories,
  handleResetState,
} from "../../Action/actions";

export default function UploadButton({
  uploadFileData,
  handleFileUplaod,
  inputFileValue,
  setSeekerEmail,
  setExpertEmail,
}) {
  const state = useSelector((state) => state.atomizer);
  const arr = [];

  state?.uploadFileData &&
    Object.entries(state?.uploadFileData)?.map(([key, value]) => {
      arr.push(state?.uploadFileData[key].name);
    });

  const renderAcceptType = () => {
    let type = "";
    switch (state?.sourceType) {
      case "PDF":
        type = "application/pdf";
        break;
      case "PDF Native":
        type = "zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed";
        break;
      case "Video":
        type = "video/mp4,video/x-m4v,video/*";
        break;
      case "Image":
        type = "image/*";
        break;
      case "List of PDF URL Links (CSV)":
      case "List of Bloomfire Links (CSV)":
        type = ".CSV";
        break;
      case "Q&A List (CSV)":
        type = ".xlsx, .xls";

        break;
      default:
        type = "";
    }
    return type;
  };
  const renderLabel = () => {
    let type = "";
    switch (state?.sourceType) {
      case "PDF":
      case "Video":
      case "Image":
        type = `a ${state?.sourceType}`;
        break;
      case "List of PDF URL Links (CSV)":
        type = "a CSV";
        break;
      case "List of Bloomfire Links (CSV)":
        type = "Files";
        break;
      case "Q&A List (CSV)":
        type = ".xls File";
        break;
      case "Multiple Files":
        type = "Files";
        break;
      case "PDF Native":
        type = "a PDF";
        break;
      default:
        type = "";
    }
    return type;
  };

  const ErrorHandle = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };

  const RenderFileName = () => {
    switch (state?.sourceType) {
      case "PDF":
      case "PDF Native":
        if (
          state?.uploadFileData !== null &&
          state?.uploadFileData?.size > 5e+7
        ) {
          toast.warning(ErrorHandle(` File too large : max 50 MB`), {
            toastId: "pdf",
            position: toast.POSITION.TOP_RIGHT,
          });
          store.dispatch(handleResetState(initialState));
          // store.dispatch(fileUploadError("PDF"));
        }
        if (
          state?.uploadFileData !== null &&
          state?.uploadFileData?.size < 5e+7
        ) {
          return (
            <div>
              {uploadFileData?.name?.length > 0 ? (
                <div
                  className={styles.fileName}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    // flexWrap: "nowrap",
                    alignItems: "baseline",
                    width: "99%",
                  }}
                >
                  <i
                    class="fa fa-file-pdf-o"
                    aria-hidden="true"
                    style={{
                      color: "red",
                      marginLeft: "10px",
                      // marginTop: "10px",

                      fontSize: "14px",
                      textAlign: "left",
                    }}
                  />

                  <p style={{ marginLeft: "3px",marginBottom:"0px" }}>{uploadFileData?.name}</p>
                </div>
              ) : null}
            </div>
          );
        }
        break;

      case "Image":
        if (
          state?.uploadFileData !== null &&
          state?.uploadFileData?.size > 2.5e+7
        ) {
          toast.warning(ErrorHandle(` File too large : max 25 MB`), {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "image",
          });
          store.dispatch(handleResetState(initialState));
          // store.dispatch(handlePageRefresh(initialState));
        }
        if (
          state?.uploadFileData !== null &&
          state?.uploadFileData?.size < 2.5e+7
        ) {
          return (
            <div>
              {uploadFileData?.name?.length > 0 ? (
                <div
                  className={styles.fileName}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "baseline",
                    width: "99%",
                    // flexWrap: "wrap",
                  }}
                >
                  <i
                    class="fa fa-file-image-o"
                    aria-hidden="true"
                    // color="red"
                    style={{
                      color: "grey",
                      marginLeft: "10px",
                      marginTop: "10px",
                      fontSize: "14px",
                    }}
                  >
                    {""}
                  </i>
                  <p style={{ marginLeft: "3px",marginBottom:"0px" }}>{uploadFileData?.name}</p>
                </div>
              ) : null}
            </div>
          );
        }
        break;
      case "Video":
        if (
          state?.uploadFileData !== null &&
          state?.uploadFileData?.size > 1.126e+9
        ) {
          // store.dispatch(initailPage("PDF"));
          toast.warning(ErrorHandle(` File too large : max 1126 MB`), {
            toastId: "video",
            position: toast.POSITION.TOP_RIGHT,
          });
          store.dispatch(handleResetState(initialState));
        }
        if (
          state?.uploadFileData !== null &&
          state?.uploadFileData?.size < 1.126e+9
        ) {
          return (
            <div>
              {uploadFileData?.name?.length > 0 ? (
                <div
                  className={styles.fileName}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "baseline",
                    width: "99%",
                    // flexWrap: "wrap",
                  }}
                >
                  <i
                    className="fa fa-film"
                    aria-hidden="true"
                    // color="red"
                    style={{
                      color: "red",
                      marginLeft: "10px",
                      marginTop: "10px",
                      fontSize: "14px",
                    }}
                  >
                    {""}
                  </i>
                  <p style={{ marginLeft: "3px",marginBottom:"0px" }}>{uploadFileData?.name}</p>
                </div>
              ) : null}
            </div>
          );
        }
        break;
      case "List of PDF URL Links (CSV)":
        if (
          state?.uploadFileData !== null &&
          state?.uploadFileData?.size > 1.5e7
        ) {
          toast.warning(ErrorHandle(` File too large : max 15 MB`), {
            toastId: "pdf_url",
            position: toast.POSITION.TOP_RIGHT,
          });
          store.dispatch(handleResetState(initialState));
        }
        if (
          state?.uploadFileData !== null &&
          state?.uploadFileData?.size < 1e7
        ) {
          return (
            <div>
              {uploadFileData?.name?.length > 0 ? (
                <div
                  className={styles.fileName}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "baseline",
                    width: "99%",
                    // flexWrap: "wrap",
                  }}
                >
                  <i
                    className=" fa fa-file-excel-o"
                    aria-hidden="true"
                    // color="red"
                    style={{
                      color: "grey",
                      marginLeft: "10px",
                      marginTop: "10px",
                      fontSize: "14px",
                      wordBreak: 'break-word',overflowWrap: 'break-word',
                    }}
                  >
                    {""}
                  </i>
                  <p style={{ marginLeft: "3px" ,marginBottom:"0px"}}>{uploadFileData?.name}</p>
                </div>
              ) : null}
            </div>
          );
        }
        break;
      case "Q&A List (CSV)":
        if (state?.uploadFileData?.size > 1.5e7) {
          store.dispatch(handleResetState(initialState));
          setSeekerEmail([]);
          setExpertEmail([]);
          store.dispatch(handleResetCategories(!state?.Catogarie));
          toast.warning(ErrorHandle(` File too large : max 15 MB`), {
            toastId: "Q&A",
            position: toast.POSITION.TOP_RIGHT,
          });
          // store.dispatch(handleExpertInput(null));
        }
        if (
          state?.uploadFileData !== null &&
          state?.uploadFileData?.size < 1.5e7
        ) {
          return (
            <div>
              {uploadFileData?.name?.length > 0 ? (
                <div
                  className={styles.fileName}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "baseline",
                    width: "99%",
                    // flexWrap: "wrap",
                  }}
                >
                  <i
                    className=" fa fa-file-excel-o"
                    aria-hidden="true"
                    color="red"
                    style={{
                      color: "red",
                      marginLeft: "10px",
                      size: "20px",
                      marginTop: "10px",
                      fontSize: "14px",
                      wordBreak: 'break-word',overflowWrap: 'break-word',
                    }}
                  >
                    {""}
                  </i>
                  <p style={{ marginLeft: "3px" ,marginBottom:"0px"}}>{uploadFileData?.name}</p>
                </div>
              ) : null}
            </div>
          );
        }

        break;
      case "List of Bloomfire Links (CSV)":
        return (
          <>
            {state?.uploadFileData !== null ? (
              <div style={{ marginLeft: "10px" }}>
                {state?.uploadFileData &&
                  Object.values(state?.uploadFileData).map((value, index) => {
                    return (
                      <div
                        className={styles.fileName}
                        key={index}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "baseline",
                        }}
                      >
                        {value?.name?.toString().endsWith("csv") ? (
                          <i
                            className=" fa fa-file-excel-o"
                            aria-hidden="true"
                            color="red"
                            style={{
                              color: "grey",
                              marginTop: "10px",
                              letterSpacing: "5px",
                              fontSize: "14px",
                              wordBreak: 'break-word',overflowWrap: 'break-word',
                              textAlign: "left",
                              alignItems: "baseline",
                            }}
                          />
                        ) : null}
                        {/* <p>{value.name?.toLowerCase()}</p> */}
                        {value.name}
                      </div>
                    );
                  })}
              </div>
            ) : null}
          </>
        );
      // break;
      case "Multiple Files":
        return (
          <>
            {state?.uploadFileData !== null ? (
              <div style={{ marginLeft: "10px" }}>
                {state?.uploadFileData &&
                  Object.values(state?.uploadFileData).map((value, index) => {
                    return (
                      <div
                        className={styles.fileName}
                        key={index}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "baseline",
                          // marginLeft: "5px",
                        }}
                      >
                        {value?.name?.toString().endsWith("pdf") ? (
                          <i
                            class="fa fa-file-pdf-o"
                            aria-hidden="true"
                            color="red"
                            style={{
                              color: "red",
                              // marginLeft: "10px",
                              marginTop: "10px",
                              // letterSpacing: "15px",
                              letterSpacing: "5px",
                              fontSize: "14px",
                              textAlign: "left",
                              alignItems: "baseline",
                            }}
                          />
                        ) : value?.name?.toString().endsWith("png") ? (
                          <i
                            class="fa fa-file-image-o"
                            aria-hidden="true"
                            style={{
                              color: "grey",
                              // marginLeft: "10px",
                              marginTop: "10px",
                              letterSpacing: "5px",
                              fontSize: "14px",
                              textAlign: "left",
                              alignItems: "baseline",
                            }}
                          />
                        ) : value?.name?.toString().endsWith("sav") ? (
                          <i
                            class="fa fa-file-image-o"
                            aria-hidden="true"
                            style={{
                              color: "grey",
                              // marginLeft: "10px",
                              marginTop: "10px",
                              letterSpacing: "5px",
                              fontSize: "14px",
                              textAlign: "left",
                              alignItems: "baseline",
                            }}
                          />
                        ) : value?.name?.toString().endsWith("jpeg") ? (
                          <i
                            class="fa fa-file-image-o"
                            aria-hidden="true"
                            style={{
                              color: "grey",
                              // marginLeft: "10px",
                              marginTop: "10px",
                              letterSpacing: "5px",
                              fontSize: "14px",
                              textAlign: "left",
                              alignItems: "baseline",
                            }}
                          />
                        ) : value?.name?.toString().endsWith("mp4") ? (
                          <i
                            className="fa fa-film"
                            aria-hidden="true"
                            color="red"
                            style={{
                              color: "red",
                              // marginLeft: "10px",
                              marginTop: "10px",
                              letterSpacing: "5px",
                              fontSize: "14px",
                              textAlign: "left",
                              alignItems: "baseline",
                            }}
                          />
                        ) : value?.name?.toString().endsWith("webm") ? (
                          <i
                            className="fa fa-film"
                            aria-hidden="true"
                            color="red"
                            style={{
                              color: "red",
                              // marginLeft: "10px",
                              marginTop: "10px",
                              letterSpacing: "5px",
                              fontSize: "12px",
                              textAlign: "left",
                              alignItems: "baseline",
                            }}
                          />
                        ) : value?.name?.toString().endsWith("jpg") ? (
                          <i
                            class="fa fa-file-image-o"
                            aria-hidden="true"
                            style={{
                              color: "grey",
                              // marginLeft: "10px",
                              marginTop: "10px",
                              letterSpacing: "5px",
                              fontSize: "14px",
                              textAlign: "left",
                              alignItems: "baseline",
                            }}
                          />
                        ) : value?.name?.toString().endsWith("png") ? (
                          <i
                            class="fa fa-file-image-o"
                            aria-hidden="true"
                            style={{
                              color: "grey",
                              // marginLeft: "10px",
                              marginTop: "10px",
                              letterSpacing: "5px",
                              fontSize: "14px",
                              textAlign: "left",
                              alignItems: "baseline",
                            }}
                          />
                        ) : value?.name?.toString().endsWith("jpeg") ? (
                          <i
                            class="fa fa-file-image-o"
                            aria-hidden="true"
                            style={{
                              color: "grey",
                              marginTop: "10px",
                              letterSpacing: "5px",
                              fontSize: "14px",
                              textAlign: "left",
                              alignItems: "baseline",
                            }}
                          />
                        ) : value?.name?.toString().endsWith("mp4") ? (
                          <i
                            className="fa fa-film"
                            aria-hidden="true"
                            color="red"
                            style={{
                              color: "red",
                              marginTop: "10px",
                              letterSpacing: "5px",
                              fontSize: "12px",
                              textAlign: "left",
                              alignItems: "baseline",
                            }}
                          />
                        ) : value?.name?.toString().endsWith(".xls") ? (
                          <i
                            className=" fa fa-file-excel-o"
                            aria-hidden="true"
                            color="red"
                            style={{
                              color: "red",
                              marginTop: "10px",
                              letterSpacing: "5px",
                              fontSize: "14px",
                              textAlign: "left",
                              alignItems: "baseline",
                            }}
                          />
                        ) : value?.name?.toString().endsWith(".xlsx") ? (
                          <i
                            className=" fa fa-file-excel-o"
                            aria-hidden="true"
                            color="red"
                            style={{
                              color: "red",
                              marginTop: "10px",
                              letterSpacing: "5px",
                              fontSize: "14px",
                              textAlign: "left",
                              alignItems: "baseline",
                            }}
                          />
                        ) : value?.name?.toString().endsWith("csv") ? (
                          <i
                            className=" fa fa-file-excel-o"
                            aria-hidden="true"
                            color="red"
                            style={{
                              color: "grey",
                              marginTop: "10px",
                              letterSpacing: "5px",
                              fontSize: "14px",
                              wordBreak: 'break-word',overflowWrap: 'break-word',
                              textAlign: "left",
                              alignItems: "baseline",
                            }}
                          />
                        ) : null}
                        {/* <p>{value.name?.toLowerCase()}</p> */}
                        {value.name}
                      </div>
                    );
                  })}
                {}
              </div>
            ) : null}
          </>
        );
      default:
        break;
    }
  };
  const style = {
    minWidth: "127px",
  };

  return (
    <>
      <div className={styles.formInputsContainer}>
        <div style={{ display: "flex" }}>
          <label
            for="actual-btn"
            className={styles.chooseFile}
            disabled={state?.loading ? true : false}
            tabIndex={-1}
            style={{
              minWidth:
                state?.sourceType === "PDF"||"PDF Native"
                  ? "117px"
                  : state?.sourceType === "Image"
                  ? "136px"
                  : state?.sourceType === "Video"
                  ? "127px"
                  : state?.sourceType === "Multiple Files"
                  ? "107px"
                  : state?.sourceType === "List of Bloomfire Links (CSV)"
                  ? "107px"
                  : state?.sourceType === "Q&A List (CSV)"
                  ? "125px"
                  : state?.sourceType === "List of PDF URL Links (CSV)"
                  ? "117px"
                : "136px",
                  // background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
            }}
          >
            Choose {renderLabel()}
          </label>

          {state?.sourceType === "Multiple Files" ? (
            <input
              type="file"
              id="actual-btn"
              hidden
              multiple={"multiple"}
              required
              accept={renderAcceptType()}
              onChange={handleFileUplaod}
              disabled={state?.loading ? true : false}
            />
          ) : state?.sourceType === "List of Bloomfire Links (CSV)" ? (
            <input
              type="file"
              id="actual-btn"
              hidden
              multiple={"multiple"}
              required
              accept={renderAcceptType()}
              onChange={handleFileUplaod}
              disabled={state?.loading ? true : false}
              // value={state?.inputUploadValue ? null : ""}
            />
          ) : (
            <input
              type="file"
              id="actual-btn"
              hidden
              required
              accept={renderAcceptType()}
              onChange={handleFileUplaod}
              disabled={state?.loading ? true : false}
              value={state?.inputUploadValue ? null : ""}
            />
          )}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          textAlign: "left",
          // width: "84.5%",
          alignItems: "baseline",
        }}
      >
        <span
          style={{
            display:
              state?.sourceType === "Multiple Files" ||
              state?.sourceType === "List of Bloomfire Links (CSV)"
                ? "column"
                : "flex",
          }}
          className={styles.formInputs}
        >
          {" "}
          <RenderFileName />
        </span>

      </div>
    </>
  );
}
